/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateCheckout200ResponseAllOfData } from './UpdateCheckout200ResponseAllOfData';
import {
    UpdateCheckout200ResponseAllOfDataFromJSON,
    UpdateCheckout200ResponseAllOfDataFromJSONTyped,
    UpdateCheckout200ResponseAllOfDataToJSON,
} from './UpdateCheckout200ResponseAllOfData';

/**
 * 
 * @export
 * @interface UpdateCheckout200Response
 */
export interface UpdateCheckout200Response {
    /**
     * 
     * @type {UpdateCheckout200ResponseAllOfData}
     * @memberof UpdateCheckout200Response
     */
    data: UpdateCheckout200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof UpdateCheckout200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the UpdateCheckout200Response interface.
 */
export function instanceOfUpdateCheckout200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function UpdateCheckout200ResponseFromJSON(json: any): UpdateCheckout200Response {
    return UpdateCheckout200ResponseFromJSONTyped(json, false);
}

export function UpdateCheckout200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCheckout200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': UpdateCheckout200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function UpdateCheckout200ResponseToJSON(value?: UpdateCheckout200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': UpdateCheckout200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

